/* OsPlanServerImagesComponent.js */

"use strict";
const _ = require("lodash");
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./OsPlanServerImagesRenderer");
const PagingImagesFeed = require("./PagingImagesFeed");
const { IMAGE_TYPES_FILTER } = require("../../../../../../../lmrbcomponents/fileexplorer/fileConstants");

class OsPlanServerImagesComponent extends EventEmitter {
    constructor(imageDetailsView) {
        super();
        this._imageDetailsView = imageDetailsView;
        this._gameEditor = imageDetailsView.getGameEditor();
        this._osPlan = this._gameEditor.getPlan();
        this._osImagePathsEntity = this._gameEditor.osImagePathsEntity;
        this._osImageEntity = this._imageDetailsView._osImageEntity;
        this._gridKey = "OsPlanServer_images";
        this._activeOrgId = this._gameEditor.activeOrgId;
        this._images = this._imageDetailsView._images;
        this._pathsData = undefined;
        this._currentSelection = [];
        this._selectedImages = [];
        this._selectedImagesRelationFeed = undefined;
        this._key = imageDetailsView.key;
        this._renderer = new Renderer(this);
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {}

    _unregisterListeners() {}

    shutdown() {
        if (!this._renderer) {
            return Promise.resolve();
        } else {
            return this._renderer
                .shutdown()
                .then(() => {
                    this._imageDetailsView = undefined;
                    this._gameEditor = undefined;
                    this._osImagePathsEntity = undefined;
                    this._osImageEntity = undefined;
                    this._osPlanServerEntity = undefined;
                    this._renderer = undefined;
                    this._activeOrgId = undefined;
                    this._gridKey = undefined;
                    this._pathsData = undefined;
                    this._selectedImages = undefined;
                    this._selectedImagesFeed = undefined;
                    this._currentSelection = undefined;
                })
                .catch((err) => {
                    console.error(err);
                });
        }
    }

    groupTree(data = []) {
        const rootId = null;
        const map = data.reduce((map, item) => {
            const { id, parentId } = item;
            map[id] = map[id] || { children: [] };

            Object.assign(map[id], item);

            if (parentId === rootId) {
                map[parentId] = map[id];
            } else {
                map[parentId] = map[parentId] || { id: parentId, children: [] };
                map[parentId].children.push(map[id]);
            }
            return map;
        }, {});
        return map[rootId];
    }

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    get gameEditor() {
        return this._gameEditor;
    }

    get imageDetailsView() {
        return this._imageDetailsView;
    }

    get renderer() {
        return this.getRenderer();
    }
    getRenderer() {
        return this._renderer;
    }

    getOsPlanServerEntity() {
        return this._osPlanServerEntity;
    }

    get osPlanServerEntity() {
        return this.getOsPlanServerEntity();
    }

    getName(name) {
        // Removing UUID prefix
        if (name[36] === "/") {
            name = name.substring(37);
        }
        return name;
    }

    whenModelIsReady() {
        return this.whenSelectedImagesModelIsReady()
            .then((feed) => {
                this._selectedImagesFeed = Object.values(_.get(feed, "cache"));
                this._selectedImages = this._selectedImagesFeed
                    .filter((image) => {
                        if (
                            _.get(this._osPlan, "_pristineProperties.imageAssociations." + this._key + ".imageIds", []).includes(_.get(image, "id"))
                        ) {
                            return true;
                        }
                    })
                    .map((image) => this._getConvertedImageDataFromFeed(image, true));
                return this._osImagePathsEntity.retrievePaths(this._activeOrgId);
            })
            .then((pathsEntity) => {
                return pathsEntity.getPaths();
            })
            .then((paths) => {
                this._pathsData = paths;
            });
    }

    whenSelectedImagesModelIsReady() {
        if (this._gameEditor._pagingImagesFeed) {
            if (_.get(this._gameEditor._pagingImagesFeed, "feed.status", false) === "SHUTDOWN") {
                this._gameEditor._pagingImagesFeed._feedReestablish().then(() => {
                    return this._gameEditor._pagingImagesFeed;
                });
            } else {
                return Promise.resolve(this._gameEditor._pagingImagesFeed);
            }
        } else {
            this._gameEditor._pagingImagesFeed = new PagingImagesFeed({
                feedKey: "selected-images" + "_feed",
                activeOrgId: this._gameEditor._activeOrgId,
                entityDef: this._osPlan,
                columnConfig: {},
                filter: {},
                sort: {}
            });
            return this.whenFeedIsReady();
        }
    }

    whenFeedIsReady() {
        return this._gameEditor._pagingImagesFeed.whenFeedReady();
    }

    _reestablishFeed() {
        this._gameEditor._pagingImagesFeed._feedReestablish();
    }

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /* START HANDLER METHODS                   */
    /*******************************************/

    _onShutdown() {
        this.shutdown();
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/
    _getConvertedImageDataFromFeed(currentImage, isSaved) {
        const imageType = IMAGE_TYPES_FILTER[currentImage.getImageType()] || "DEFAULT";
        const name = `${this.getName(currentImage.pristineProperties.name)} (${imageType.title || "Unknown"})`;
        return {
            id: currentImage.id,
            parentId: currentImage.pristineProperties.pathId,
            name,
            type: "image",
            fileType: currentImage.pristineProperties.fileType,
            fileSize: currentImage.pristineProperties.fileSize,
            imageType: currentImage.pristineProperties.imageType,
            isSaved: isSaved
        };
    }

    _getConvertedImageDataFromSelectedImages(currentImage) {
        // const imageType = IMAGE_TYPES_FILTER[currentImage.getImageType()] || 'DEFAULT';
        // const name = `${currentImage.name} (${imageType.title || 'Unknown'})`;
        return {
            id: currentImage.id,
            parentId: currentImage.parentId,
            name: currentImage.name,
            fileType: currentImage.fileType,
            fileSize: currentImage.fileSize,
            imageType: currentImage.imageType,
            type: "image"
        };
    }

    _getSelectedImagesIds() {
        this._selectedImages.map((image) => {
            return image.id;
        });
    }

    getImagesForPath() {
        return this._osImageEntity.loadOsImages(this._activeOrgId, {}, {}, {}, false);
    }
    /*******************************************/
    /* END PRIVATE METHODS                     */
    /*******************************************/
}
module.exports = OsPlanServerImagesComponent;
